type Listener<T> = (data: T) => void;

class EventBus<T = any> {
  private events: { [key: string]: Listener<T>[] } = {};

  // Subscribe to an event
  subscribe(event: string, listener: Listener<T>): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }

  // Unsubscribe from an event
  unsubscribe(event: string, listener: Listener<T>): void {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(l => l !== listener);
  }

  // Emit an event to notify listeners
  emit(event: string, data: T): void {
    if (!this.events[event]) return;
    this.events[event].forEach(listener => listener(data));
  }
}

// Exporting a single instance of EventBus
export const eventBus = new EventBus();
